








import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BaseDivider',
  data(...args): any {
    return args;
  },
});
